export default __webpack_public_path__ + "static/orix_signature_logo-c043535c32ac3085f7dfd326abeaf82a.avif";